module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-1451a23c!./packages/dof-music-player/colmo.css
// module id = 425
// module chunks = 0 1